import { render } from "./BpmOgpoGlobalLoader.vue?vue&type=template&id=54defb24&scoped=true"
import script from "./BpmOgpoGlobalLoader.vue?vue&type=script&lang=js"
export * from "./BpmOgpoGlobalLoader.vue?vue&type=script&lang=js"

import "./BpmOgpoGlobalLoader.vue?vue&type=style&index=0&id=54defb24&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54defb24"]])

export default __exports__